import React, {useState, useEffect} from 'react';
import Section from '../../../../Components/Containers/Section';
import Modal, { usePreventDismissing } from '../../../../Components/Modal';
import ButtonRow from '../../../../Components/Button/ButtonRow';
import Button from '../../../../Components/Button/Button';
import { useOpenVideo } from '../../../../Services/helpers';
import { useDialogues } from '../../../../Components/Dialogues';

const ignoredSteps = [
    'PricingCategories',
];

const NextSteps = ({isShowing, setIsShowing, theJourney}) => {
    const {journey, markStepDone, markStepSkipped, isSaving} = theJourney;
    const [showingStep, setShowingStep] = useState(null);
    const [nextStep, setNextStep] = useState(null);
    const [previousStep, setPreviousStep] = useState(null);
    const [stepOpen, setStepOpen] = useState(null);

    useEffect(() => {
        if (!journey) {
            return;
        }

        const steps = journey.steps
            .filter(s => !ignoredSteps.includes(s.key))
            .filter(s => s.status === 'New' || s.status === 'Started');

        const stepIds = steps.map(s => s.id);

        if (showingStep && stepIds.includes(showingStep)) {
            const index = stepIds.indexOf(showingStep);
            setPreviousStep(index === 0 ? null : stepIds[index - 1]);
            setNextStep(index === stepIds.length - 1 ? null : stepIds[index + 1]);
        } else {
            setShowingStep(stepIds[0]);
            setPreviousStep(null);
            setNextStep(stepIds[1]);
        }
    }, [journey, showingStep])

    if (!journey) {
        return null;
    }

    const step = journey.steps.find(s => s.id === showingStep);

    if (!step) {
        return null;
    }

    !isShowing && setIsShowing(true);

    return <Section title="getStarted" className="bg-slate-100 rounded-xl border shadow-md p-3">
        <Step key={step.id} {...{step, setStepOpen}} />
        {stepOpen && <StepModal closeModal={() => setStepOpen(null)}
            {...{step, markStepDone, markStepSkipped, isSaving, nextStep, previousStep, setShowingStep}}
        />}
    </Section>
}

const Step = ({step, setStepOpen}) => {

    let description = step.description;
    if (description.length > 200) {
        description = <>
            {description.split(' ').slice(0, 20).join(' ').replace(/[\s.]+$/, '')}...
            &nbsp;
            <span className="text-brand">Read more</span>
        </>
    }

    return <>
        <div className="h-full flex flex-col">
            <div className="grow">
                {/* <p className="font-bold" onClick={() => setStepOpen(true)}>{step.title}</p> */}
                <p onClick={() => setStepOpen(true)}>{description}</p>
            </div>
        </div>
    </>
}

const StepModal = ({step, isSaving, markStepDone, markStepSkipped, closeModal, nextStep, previousStep, setShowingStep}) => {
    return <Modal title={step.title} isOpen={true} setIsOpen={closeModal} dismissible>
        <p>{step.description}</p>
        <StepButtons {...{step, isSaving, markStepDone, markStepSkipped, nextStep, previousStep, setShowingStep}} />
    </Modal>
}

const StepButtons = ({step, isSaving, markStepDone, markStepSkipped, nextStep, previousStep, setShowingStep}) => {
    const openVideo = useOpenVideo();
    const {isDialogueOpen, confirm} = useDialogues();
    
    usePreventDismissing(isDialogueOpen);

    return <div className="flex flex-row space-between">
        <div className="grow">
            <ButtonRow arrange="left">
                <Button theme="light"
                    icon="LeftChevron"
                    disabled={!previousStep|| isSaving}
                    onClick={() => previousStep && setShowingStep(previousStep)}
                />
                <Button theme="light"
                    icon="RightChevron"
                    disabled={!nextStep|| isSaving}
                    onClick={() => nextStep && setShowingStep(nextStep)}
                />
            </ButtonRow>
        </div>
        <div className="shrink-0">
            <ButtonRow>
                {step.canBeSkipped && <Button theme="light"
                    icon="VolumeSlash"
                    onClick={() => confirm(
                        {
                            theme: 'primary',
                            title: 'Temporarily mute this step',
                            confirmLabel: 'Mute',
                            message: `Are you sure you want to mute this step? It will no longer show in your getStarted guide.
                            
                            Muted steps might occasionally reappear when we update the steps or you make changes in your account.`,
                        },
                        () => markStepSkipped(step.key)
                    )}
                    disabled={isSaving}
                />}
                {step.canBeMarkedDone && <Button theme={step.link ? 'secondary' : 'primary'}
                    label="Done"
                    icon="Check"
                    onClick={() => markStepDone(step.key)}
                    disabled={isSaving}
                />}
                {step.videoId && <Button theme="primary"
                    label="Video"
                    icon="Play"
                    onClick={() => openVideo(step.videoId)}
                    disabled={isSaving}
                />}
                {step.link && <Button theme="primary"
                    label={"Go"}
                    link={step.link}
                    disabled={isSaving}
                />}
            </ButtonRow>
        </div>
    </div>
}

export default NextSteps;